import { SignupState } from "../../../store/signup/SignupState"
import NricValidator from "./NricValidator"
import NameValidator from "./NameValidator"
import CardNameValidator from "./CardNameValidator"
import DateOfBirtValidator from "./DateOfBirthValidator"
import GenderValidator from "./GenderValidator"
import MobileNumberValidator from "./MobileNumberValidator"
import EmailValidator from "./EmailValidator"
import SelectValidator from "./SelectValidator"
import { StaticFormData } from "../../ntuc/userService/staticData"

export default (state: SignupState, staticData: StaticFormData | undefined): Promise<void> => new Promise((resolve, reject) => {
    const validNric = validateNric(state)
    const validName = validateName(state.personalDetail.name)
    const validCardName = validateCardName(state.personalDetail.cardName)
    const validDateOfBirth = validateDateOfBirth(state)
    const validGender = validateGender(state.personalDetail.gender)
    const validMobileNumber = validateMobileNumber(state)
    const validEmail = validateEmail(state)
    const validRace = validateRace(state, staticData)
    const validMaritalStatus = validateMaritalStatus(state, staticData)
    const validResidentialStatus = validateResidentialStatus(state, staticData)
    const validEducationalStatus = validateEducationalStatus(state, staticData)

    const validationResult = initialPersonalDetailsFormValidation()
    let isValid = true

    if (validNric) {
        validationResult.nricValidationMessage = validNric
        isValid = false
    }

    if (validName) {
        validationResult.nameValidationMessage = validName
        isValid = false
    }

    if (validCardName) {
        validationResult.cardNameValidationMessage = validCardName
        isValid = false
    }

    if (validDateOfBirth) {
        validationResult.dateOfBirthValidationMessage = validDateOfBirth
        isValid = false
    }

    if (validGender) {
        validationResult.genderValidationMessage = validGender
        isValid = false
    }

    if (validMobileNumber) {
        validationResult.mobileNumberValidationMessage = validMobileNumber
        isValid = false
    }

    if (validEmail) {
        validationResult.emailValidationMessage = validEmail
        isValid = false
    }

    if (validRace) {
        validationResult.raceValidationMessage = validRace
        isValid = false
    }

    if (validMaritalStatus) {
        validationResult.maritalStatusValidationMessage = validMaritalStatus
        isValid = false
    }

    if (validResidentialStatus) {
        validationResult.residentialStatusValidationMessage = validResidentialStatus
        isValid = false
    }

    if (validEducationalStatus) {
        validationResult.educationalStatusValidationMessage = validEducationalStatus
        isValid = false
    }

    if (isValid) {
        resolve()
    } else {
        reject(validationResult)
    }

})

export const processMobileNumber = (value: string) => {
    const REGEX = /^\+65/g
    return value.replace(REGEX, ``)
}

const validateNric = (state: SignupState): string | undefined => {
    return (new NricValidator()).validate(state.personalDetail.nric)
}

export const validateName = (value: string): string | undefined => {
    return (new NameValidator()).validate(value)
}

export const validateCardName = (value: string): string | undefined => {
    return (new CardNameValidator()).validate(value)
}

const validateDateOfBirth = (state: SignupState): string | undefined => {
    return (new DateOfBirtValidator()).validate(state.personalDetail.dateOfBirth)
}

export const validateGender = (value: string): string | undefined => {
    return (new GenderValidator()).validate(value)
}

const validateMobileNumber = (state: SignupState): string | undefined => {
    return (new MobileNumberValidator()).validate(processMobileNumber(state.personalDetail.mobileNumber))
}

const validateEmail = (state: SignupState): string | undefined => {
    return (new EmailValidator()).validate(state.personalDetail.email)
}

const validateRace = (state: SignupState, staticData: StaticFormData | undefined): string | undefined => {
    return (new SelectValidator(staticData ? staticData.race : [])).validate(state.personalDetail.race)
}

const validateMaritalStatus = (state: SignupState, staticData: StaticFormData | undefined): string | undefined => {
    return (new SelectValidator(staticData ? staticData.marital_status : [])).validate(state.personalDetail.maritalStatus)
}

const validateResidentialStatus = (state: SignupState, staticData: StaticFormData | undefined): string | undefined => {
    return (new SelectValidator(staticData ? staticData.residential_status : [])).validate(state.personalDetail.residentialStatus)
}

const validateEducationalStatus = (state: SignupState, staticData: StaticFormData | undefined): string | undefined => {
    return (new SelectValidator(staticData ? staticData.education_level : [])).validate(state.personalDetail.educationalStatus)
}

export interface PersonalDetailsFormValidation {
    nricValidationMessage: string | undefined
    nameValidationMessage: string | undefined
    cardNameValidationMessage: string | undefined
    dateOfBirthValidationMessage: string | undefined
    genderValidationMessage: string | undefined
    mobileNumberValidationMessage: string | undefined
    emailValidationMessage: string | undefined
    raceValidationMessage: string | undefined
    maritalStatusValidationMessage: string | undefined
    residentialStatusValidationMessage: string | undefined
    educationalStatusValidationMessage: string | undefined
}

const initialPersonalDetailsFormValidation = (): PersonalDetailsFormValidation => ({
    nricValidationMessage: undefined,
    nameValidationMessage: undefined,
    cardNameValidationMessage: undefined,
    dateOfBirthValidationMessage: undefined,
    genderValidationMessage: undefined,
    mobileNumberValidationMessage: undefined,
    emailValidationMessage: undefined,
    raceValidationMessage: undefined,
    maritalStatusValidationMessage: undefined,
    residentialStatusValidationMessage: undefined,
    educationalStatusValidationMessage: undefined,
})
